import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "antd";
import { useHistory } from "react-router-dom";
import Gif from "../../img/procesando.gif";
import imgCheck from "../../img/check.png";
import { fnNewOrder } from "../../data/sales";
import qz from "qz-tray";
import { API, httpClient } from "../../util/api";
import { clearOrderData } from "../../util/functions";
import html2canvas from "html2canvas";

function ModalSendOrderToCheckout({ listFinal, pFinal }) {
  const [show, setShow] = useState(true);
  const [message, setMessage] = useState("Enviando pedido…");
  const [message2, setMessage2] = useState("");
  const [imageModal, setImageModal] = useState(Gif);
  const history = useHistory();
  const timeoutRef = useRef(null);

  const tipoDoc = sessionStorage.getItem("tipoComprobante");
  const cliente = JSON.parse(sessionStorage.getItem("datosClientePedido"));
  const establecimiento = JSON.parse(localStorage.getItem("token_activo"))
    .data[0].idEstableciomiento;

  const tipoPedido = localStorage.getItem("tipoPedido");

  const syncOrderToSian = async (orderId) => {
    try {
      console.log("Iniciando sincronización con SIAN para orden:", orderId);
      const response = await httpClient.post(`/ventas/sincronizar`, {
        idVenta: orderId,
      });

      if (response.data.success) {
        console.log("✅ Orden sincronizada con SIAN exitosamente");
      } else {
        console.error("❌ Error al sincronizar con SIAN:", response.data);
      }
    } catch (error) {
      console.error("❌ Error en sincronización con SIAN:", error);
      // No bloquear el flujo si falla la sincronización
    }
  };

  const sendOrder = async () => {
    const params = {
      montoCentimos: parseInt(
        parseFloat(parseFloat(pFinal).toFixed(2)) * 100,
        10
      ),
      montoTotal: parseFloat(pFinal).toFixed(2),
      idEstableciomiento: establecimiento,
      listaFinal: listFinal,
      tipoDoc: tipoDoc,
      cliente: cliente,
      tipoPedido:
        tipoPedido === "toGo" ? "Para llevar" : "Para consumir en el local",
    };

    console.log(`params`, params);
    const response = await fnNewOrder(params);
    console.log(`response`, response);

    if (!response.data.success)
      throw new Error("No se pudo obtener el número de orden");

    const purchaseOrderNumber = response.data.data;
    console.log(`purchaseOrderNumber`, purchaseOrderNumber);
    sessionStorage.setItem("purchaseOrderNumber", purchaseOrderNumber);
    sessionStorage.setItem("orderId", JSON.stringify(purchaseOrderNumber));
    // borrar el localstorage del pedido
    clearOrderData();
    return purchaseOrderNumber;
  };

  const printOrder = async (
    printer,
    dataPrint,
    objByConfig = null,
    _callback = null,
    cortar = false
  ) => {
    try {
      qz.security.setCertificatePromise(function (resolve, reject) {
        fetch(`${API}/files/cert`, {
          cache: "no-store",
          headers: { "Content-Type": "text/plain" },
        }).then(function (data) {
          data.ok ? resolve(data.text()) : reject(data.text());
        });
      });

      qz.security.setSignaturePromise(function (toSign) {
        return function (resolve, reject) {
          fetch(`${API}/qz-tray/sign-message?request=${toSign}`, {
            cache: "no-store",
            headers: { "Content-Type": "text/plain" },
          }).then(function (data) {
            data.ok ? resolve(data.text()) : reject(data.text());
          });
        };
      });

      let config = null;

      console.log(`printer`, printer);
      console.log(`dataPrint`, dataPrint);

      // Timeout para continuar si la impresión tarda mucho
      const printTimeout = setTimeout(() => {
        console.warn("Timeout de impresión alcanzado, continuando...");
        if (_callback !== null) {
          _callback();
        }
      }, 15000); // 15 segundos de timeout

      const finalDataprint = await Promise.all(
        dataPrint.map(async (item) => {
          if (typeof item.data === "string" && /^https?:\/\//.test(item.data)) {
            try {
              const response = await fetch(item.data);
              console.log({ response });
              const html = await response.text();
              console.log({ html });

              // OPCIÓN A: HTML DIRECTO (MEJOR CALIDAD) - ACTIVADO
              return {
                type: "pixel",
                format: "html",
                flavor: "plain",
                data: `
                  <html>
                  <head>
                    <style>
                      @page {
                        size: 80mm auto;
                        margin: 1mm;
                      }
                      body {
                        font-family: Arial, sans-serif;
                        font-size: 9pt;
                        line-height: 1.2;
                        margin: 0;
                        padding: 1mm;
                        color: #000;
                        background: #fff;
                        width: 72mm;
                        max-width: 72mm;
                        box-sizing: border-box;
                      }
                      * {
                        font-size: 9pt !important;
                        max-width: 100%;
                      }
                      table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 8pt;
                      }
                      th, td {
                        padding: 1px;
                        text-align: left;
                        font-size: 8pt;
                        word-wrap: break-word;
                      }
                      .center { text-align: center; }
                      .right { text-align: right; }
                      .bold { font-weight: bold; }
                      hr { border: 1px solid #000; margin: 2px 0; }
                      h1, h2, h3 {
                        font-size: 10pt !important;
                        margin: 2px 0;
                      }
                    </style>
                  </head>
                  <body>
                    ${html}
                  </body>
                  </html>
                `
              };

              // OPCIÓN B: IMAGEN CON MÁXIMA CALIDAD (ACTUAL MEJORADA) - DESACTIVADO
              /*
              const container = document.createElement("div");
              container.innerHTML = html;

              // Estilo optimizado para máxima nitidez
              container.style.position = "fixed";
              container.style.left = "-9999px";
              container.style.top = "0";
              container.style.width = "576px";
              container.style.padding = "0";
              container.style.margin = "0";
              container.style.fontSize = "14px";
              container.style.fontFamily = "Arial, sans-serif";
              container.style.lineHeight = "1.3";
              container.style.color = "#000000";
              container.style.backgroundColor = "#ffffff";
              container.style.webkitFontSmoothing = "none"; // Desactivar suavizado
              container.style.fontSmooth = "never";
              container.id = "print-preview";

              document.body.appendChild(container);

              const canvas = await html2canvas(container, {
                scale: 4,           // 👈 Máxima densidad de píxeles
                width: 576,
                height: container.scrollHeight,
                windowWidth: 576,
                useCORS: true,
                allowTaint: false,
                backgroundColor: '#ffffff',
                logging: false,
                imageTimeout: 15000,
                removeContainer: true,
                pixelRatio: 4,      // 👈 Forzar alta resolución
                foreignObjectRendering: false // 👈 Mejor compatibilidad
              });

              document.body.removeChild(container);

              // Extraer imagen base64 sin encabezado
              const base64 = canvas.toDataURL("image/png", 1.0).split(",")[1]; // 👈 Máxima calidad PNG

              return {
                type: "pixel",
                format: "image",
                flavor: "base64",
                data: base64,
                options: {
                  altFontRendering: true,
                  ignoreTransparency: true // 👈 Mejor para texto
                }
              };
              */
            } catch (error) {
              console.error(
                "Error al procesar HTML:",
                item.data,
                error
              );
              return null;
            }
          } else {
            return item;
          }
        })
      );

      console.log({ finalDataprint });

      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }

      console.log(`connect ${printer}`);

      if (objByConfig === null) {
        console.log("NOT objByConfig");
        // Configuración optimizada para tickets térmicos
        config = qz.configs.create(printer, {
          size: { width: 80, height: 200 }, // Tamaño papel térmico 80mm
          units: 'mm',
          density: 'best',        // Mejor calidad disponible
          colorType: 'grayscale', // Escala de grises para mejor contraste
          interpolation: 'nearest-neighbor', // Mejor para texto nítido
          scaleContent: true,     // Escalar al tamaño del papel
          margins: { top: 1, right: 1, bottom: 1, left: 1 } // Márgenes mínimos
        });
      } else {
        console.log("objByConfig");
        // Combinar configuración existente con mejoras de calidad
        const enhancedConfig = {
          ...objByConfig,
          density: objByConfig.density || 'best',
          colorType: objByConfig.colorType || 'grayscale',
          interpolation: objByConfig.interpolation || 'nearest-neighbor',
          scaleContent: objByConfig.scaleContent !== undefined ? objByConfig.scaleContent : false
        };
        config = qz.configs.create(printer, enhancedConfig);
      }

      console.log(finalDataprint);

      qz.print(config, finalDataprint).then(async () => {
        clearTimeout(printTimeout); // Limpiar timeout si imprime correctamente
        if (cortar) {
          const configCut = qz.configs.create(printer, {
            encoding: "ISO-8859-1",
            altPrinting: true,
            scaleContent: true,
          });

          const dataCut = ["\u001ba\u0001", "\n", "\n", "\u001dVA2"];

          qz.print(configCut, dataCut)
            .then(async () => {
              qz.websocket.disconnect();
              if (_callback !== null) {
                _callback();
              }
            })
            .catch((error) => {
              console.error("Error al cortar papel:", error);
              qz.websocket.disconnect();
              // Continuar aunque falle el corte
              if (_callback !== null) {
                _callback();
              }
            });
        } else {
          qz.websocket.disconnect();
          if (_callback !== null) {
            _callback();
          }
        }
      }).catch((error) => {
        clearTimeout(printTimeout); // Limpiar timeout si hay error
        console.error("Error en impresión:", error);
        qz.websocket.disconnect();
        // Continuar aunque falle la impresión
        if (_callback !== null) {
          _callback();
        }
      });
    } catch (error) {
      console.error("Error general en printOrder:", error);
      // Continuar aunque falle la impresión
      if (_callback !== null) {
        _callback();
      }
    }
  };

  const finish = () => {
    setMessage("Acércate a cancelar a caja.");
    setMessage2("GRACIAS POR TU PEDIDO");
    setImageModal(imgCheck);

    timeoutRef.current = setTimeout(() => {
      setShow(false);
      // redireccionar al main para nuevo pedido
      history.push("/main");
    }, 10000);
  };

  const goOut = () => {
    setShow(false);
    clearTimeout(timeoutRef.current); // Limpia el temporizador
    // redireccionar al main para nuevo pedido
    history.push("/main");
  };

  useEffect(() => {
    const processOrder = async () => {
      const orderId = await sendOrder();
      if (orderId > 0) {
        // Sincronizar con SIAN (sin bloquear el flujo)
        syncOrderToSian(orderId);

        setMessage("Imprimiendo pedido...");
        const data = [
          {
            type: "pixel",
            format: "pdf",
            flavor: "file",
            data: `${API}/orders/print?order_id=${orderId}&establecimiento_id=${establecimiento}`,
          },
        ];
        let printerKiosk = `POS80-KIOSCO`;
        // finish();
        printOrder(printerKiosk, data, null, finish, true);
      }
    };

    processOrder();
  }, []);

  return (
    <Modal
      visible={show}
      onCancel={goOut}
      footer={[]}
      width={900}
      centered
      modalRender={(modal) => (
        <div style={{ borderRadius: "20px", overflow: "hidden" }}>{modal}</div>
      )}
    >
      <div style={{ margin: "auto auto", height: "100%" }}>
        <div style={{ marginTop: "2rem", textAlign: "center" }}>
          <img src={imageModal} style={{ maxHeight: "350px" }} alt="cargando" />
          <h2 style={{ marginTop: "2rem", fontSize: "3.5rem" }}>{message}</h2>
          {message2 !== "" && (
            <h2 style={{ marginTop: "2rem", fontSize: "3.5rem" }}>
              {message2}
            </h2>
          )}
          {message2 !== "" && (
            <Button
              onClick={goOut}
              style={{
                backgroundColor: "#A50B70",
                marginTop: "20px",
                fontSize: "3.5rem",
                color: "#fff",
                borderRadius: "15px",
                padding: "2rem 3rem",
                height: "auto",
              }}
            >
              SALIR
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ModalSendOrderToCheckout;
